export type InvoiceLineItem = {
    number: number
    code: string
    description: string
    quantity: number
    total: number
}

type InvoiceSummary = {
    summeryTreatments?: any[]
    summeryProducts?: any[]
}

export const getInvoiceLineItems = (treatment: InvoiceSummary = {}): InvoiceLineItem[] => {
    const treatmentItems = Array.isArray(treatment.summeryTreatments) ? treatment.summeryTreatments : []
    const productItems = Array.isArray(treatment.summeryProducts) ? treatment.summeryProducts : []

    return [
        ...treatmentItems.map((item) => ({
            code: item?.operativeCode || '',
            description: item?.operativeName || '',
            quantity: item?.qty || 0,
            total: item?.total || 0
        })),
        ...productItems.map((item) => ({
            code: item?.itemCode || '',
            description: item?.itemName || '',
            quantity: item?.qty || 0,
            total: item?.total || 0
        }))
    ].map((item, index) => ({
        ...item,
        number: index + 1
    }))
}

export type UnderlineLayout = { count: number; lineHeight: number }

/**
 * Number of dashed underlines to draw under a block of text, derived from the
 * measured box height. Always a positive integer: `new Array(n)` throws
 * "Invalid array length" for a fraction, which happens whenever the line height
 * is not a divisor of the box height (e.g. the TDH invoice at 14px * 1.4).
 */
export const getUnderlineLayout = (clientHeight: number, lineHeight: number): UnderlineLayout => {
    const safeLineHeight = lineHeight > 0 ? lineHeight : 24
    const count = Math.round(clientHeight / safeLineHeight)
    return { count: Number.isFinite(count) && count >= 1 ? count : 1, lineHeight: safeLineHeight }
}

/** Resolved line height of an element in px, or `fallback` when it cannot be determined. */
export const readLineHeight = (element: Element | null, fallback: number): number => {
    if (!element) return fallback
    const style = window.getComputedStyle(element)
    const lineHeight = parseFloat(style.lineHeight)
    if (!Number.isFinite(lineHeight) || lineHeight <= 0) return fallback
    if (/px\s*$/.test(style.lineHeight)) return lineHeight
    const fontSize = parseFloat(style.fontSize)
    return Number.isFinite(fontSize) && fontSize > 0 ? lineHeight * fontSize : fallback
}
